
import { defineComponent, computed } from '@nuxtjs/composition-api';
import getStringInSnakeCase from '~/composables/useStringToSnakeCase';
import CategoryFilterBlock from '~/domains/category/components/CategoryFilterBlock';

export default defineComponent({
  name: 'CategoryFilter',
  components: { CategoryFilterBlock },
  props: {
    filters: {
      type: Array,
      default: () => [],
    },
    selectedFilters: {
      type: Object,
      default: () => {},
    },
  },
  setup(props) {
    const isSelectedFilters = computed(() =>
      Object.values(props.selectedFilters).some((arr) => arr.length)
    );
    return {
      isSelectedFilters,
      getStringInSnakeCase,
    };
  },
});
